import { useEffect } from 'react'
import i18n from '@/i18n'
import { AppShell } from '@/app/AppShell'
import { useSettingsStore } from '@/stores'

export default function App() {
  const themePreference = useSettingsStore((s) => s.themePreference)
  const language = useSettingsStore((s) => s.language)
  const setResolvedTheme = useSettingsStore((s) => s.setResolvedTheme)

  // Apply theme to <html> element
  useEffect(() => {
    const root = document.documentElement

    const applyTheme = (resolvedTheme: 'light' | 'dark') => {
      root.setAttribute('data-theme', resolvedTheme)
      root.classList.toggle('dark', resolvedTheme === 'dark')
      setResolvedTheme(resolvedTheme)
    }

    if (themePreference === 'dark') {
      applyTheme('dark')
      return
    }

    if (themePreference === 'light') {
      applyTheme('light')
      return
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const syncSystemTheme = () => applyTheme(mediaQuery.matches ? 'dark' : 'light')

    syncSystemTheme()
    mediaQuery.addEventListener('change', syncSystemTheme)

    return () => mediaQuery.removeEventListener('change', syncSystemTheme)
  }, [themePreference, setResolvedTheme])

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language)
    }
    document.documentElement.lang = language
  }, [language])

  return <AppShell />
}
